import Nav from "react-bootstrap/Nav";
import { Link, useLocation } from "react-router-dom";
import "../Water Networks/Components/Tabs.css";
import { Button } from "react-bootstrap";

const styles = {
  activeTab: {
    borderBottom: "3px solid #375EAD",
    color: "#375EAD",
    fontWeight: "bold",
    fontSize: "14px",
  },

  deactiveTab: {
    color: "rgba(30, 30, 30, 0.53)",
    fontWeight: "600",
    fontSize: "14px",
  },
  backButton: {
    background: "transparent",
    border: "none",
    fontWeight: "bold",
    color: "#000078",
    cursor: "pointer",
    alignItems: "center",
    padding: "15px 00px",
    boxShadow: "none",
  },
};
function PlantShopsBlocksTabs() {
  const path = useLocation();

  return (
    <div
      style={{
        marginTop: "30px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      {/* <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "50px",
        }}
      >
        <Link to="/reports/plantblocks">
          <Button style={styles.backButton}>
            <img
              className="img"
              alt="Vector"
              src={require("../Assets/arrowLeft.png")}
              height={20}
              width={20}
            />
          </Button>
        </Link>
        <div
          style={{ color: "#375EAD", fontWeight: "600", marginLeft: "20px" }}
        >
          Back
        </div>
      </div> */}
      <div
        style={{
          margin: "auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Nav
          id="water-tabs"
          variant="tabs"
          justify
          defaultActiveKey={
            path.pathname === "/reports/plantblocks"
              ? "/reports/plantblocks"
              : path.pathname === "/reports/plantshops"
              ? "/reports/plantshops"
              : null
          }
        >
          <Nav.Item className="navItem">
            <Nav.Link
              id="navLink"
              style={
                path.pathname === "/reports/plantblocks"
                  ? styles.activeTab
                  : styles.deactiveTab
              }
              eventKey="/reports/plantblocks"
              href="/reports/plantblocks"
            >
              Block Wise Report
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="navItem">
            <Nav.Link
              id="navLink"
              style={
                path.pathname === "/reports/plantshops"
                  ? styles.activeTab
                  : styles.deactiveTab
              }
              eventKey="/reports/plantshops"
              href="/reports/plantshops"
            >
              Shop Wise Report
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
}

export default PlantShopsBlocksTabs;
